import { Skeleton } from "antd";

export function InputSkeletonLoading({
	loading,
	children,
}: {
	loading: boolean;
	children: React.ReactNode;
}) {
	return loading ? <Skeleton.Input active={true} size="small" /> : children;
}

export function ImageSkeletonLoading({
	loading,
	children,
}: {
	loading: boolean;
	children: React.ReactNode;
}) {
	return loading ? (
		<Skeleton.Image active={true} className="w-full! h-full!" />
	) : (
		children
	);
}
